import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import throttle from 'lodash/throttle';
import { getSellableProducts, getSellableProductById, setProductListEmpty, clearPosFilter } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import POSProductCard from './POSProductCard';
import CircularProgress from '@mui/material/CircularProgress';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import 'styles/sass/pos/POSProduct.scss';

const compName = 'POSProductListPage';

class POSProductListPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            categoryId: null,
            openDialogAddProductDetails: false,
            isLoading: false,
            hasMore: true,
        };
    }

    componentDidMount() {
        if (this.props.POSProductsScroll) {
            this.handleScrollThrottled = throttle(this.handleScroll, 300);
            window.addEventListener('scroll', this.handleScrollThrottled);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (
            this.props.posOrderSaveSuccess &&
            prevProps.posOrderSaveSuccess !== this.props.posOrderSaveSuccess
        ) {
            this.setState({ isAddingProduct: false });
        }

        if (
            prevProps.productFilter !== this.props.productFilter &&
            this.props.productFilter
        ) {
            const filters = {
                productId: this.props.productFilter.productId,
                branchId: this.props.branchId
            };
            this.props.getProductbyId(filters);
            this.props.updateActivePage(1);
        }

        if (
            prevProps.POSproductFiltered !== this.props.POSproductFiltered &&
            this.props.POSproductFiltered
        ) {
            this.props.addToOrder(this.props.POSproductFiltered);
            this.props.clearPosFilter();
            this.props.setProductListEmpty();
            this.props.updateActivePage(1);
        }

        if (this.state.isLoading &&
            this.props.sellableProductsAll.length > prevProps.sellableProductsAll.length) {
            this.setState({ isLoading: false });
        }
        
        if (
            !this.arraysEqual(this.props.POSSubCategory, prevProps.POSSubCategory) ||
            !this.arraysEqual(this.props.POSWeightsList, prevProps.POSWeightsList) ||
            !this.arraysEqual(this.props.POSBrandsList, prevProps.POSBrandsList) ||
            this.props.POSBasicCategory !== prevProps.POSBasicCategory ||
            this.props.POSSortFilter !== prevProps.POSSortFilter
        ) {
            this.props.updateActivePage(1);
        }

        if (prevProps.productsLength !== this.props.productsLength) {
            this.setState({ isLoading: false });
        }

        if (this.state.hasMore && this.props.sellableProductsAll && this.props.productsLength) {
            if (this.props.sellableProductsAll.length >= this.props.productsLength) {
                this.setState({ hasMore: false });
            }
        }
    }

    componentWillUnmount() {
        if (this.props.POSProductsScroll && this.handleScrollThrottled) {
            window.removeEventListener('scroll', this.handleScrollThrottled);
        }
    }

    arraysEqual = (a, b) => {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;

        const sortedA = [...a].sort();
        const sortedB = [...b].sort();

        for (let i = 0; i < sortedA.length; ++i) {
            if (sortedA[i] !== sortedB[i]) return false;
        }

        return true;
    }

    closeAddProductDialog = () => {
        this.setState({ openDialogAddProductDetails: false, dialogProduct: null });
    }


    handleScroll = () => {
        // delete all focusing element when starting to scroll and skip the input inside the dialog
        const activeElement = document.activeElement;

        // Check if it's a checkbox or button
        const isCheckbox = activeElement?.tagName === 'INPUT' &&
        activeElement?.type === 'checkbox';
        const isButton = activeElement?.tagName === 'BUTTON';

        // Only blur if the active element is not inside the dialog
        if (
            activeElement &&
            typeof activeElement.blur === 'function' &&
            (isCheckbox || isButton)
        ) {
            activeElement.blur();
        }

        const { sellableProductsAll, productsLength, posShowProductCount, activePage } = this.props;
        const { isLoading } = this.state;
        const totalLength = sellableProductsAll ? sellableProductsAll.length : 0;
        const isMoreProduct = productsLength > posShowProductCount &&
                            totalLength !== productsLength &&
                            totalLength !== 0;

        if (isLoading || !isMoreProduct) return;

        const scrollPosition = window.innerHeight + window.pageYOffset;
        const contentHeight = document.documentElement.scrollHeight;
        const buffer = 200;
        const isScroll = scrollPosition + buffer >= contentHeight;
        
        if (isScroll && isMoreProduct && !isLoading) {
            // Block further scrolling by setting isLoading
            this.setState({ isLoading: true }, () => {
                this.props.updateActivePage(activePage + 1);
            });
        }
    };

    loadMore = (e) => {
        e.currentTarget.blur();
        this.setState({ isLoading: true }, () => {
            this.props.updateActivePage(this.props.activePage + 1);
        });
    }

    render() {
        const p = this.props;
        const { sellableProductsAll, productsLength, posShowProductCount, activePage, t } = this.props;
        const { isLoading, hasMore } = this.state;
        const products = p.POSProductsScroll ? p.sellableProductsAll : p.products;
        const productsItems = (
            <div className="row-flex shop_product_container">
                {
                    products && products.length > 0 ? products.map((item, index) => {
                        return (
                            <React.Fragment key={item.id}>
                                {this.props.showImageInPOSPage ?
                                    <POSProductCard openDetailLog={() => this.props.addToOrder(item)} item={item} />
                                    :
                                    <Button
                                        label={item.name}
                                        className="btn btn-grid sale_products_button"
                                        onTouchTap={() => this.props.addToOrder(item)}
                                        key={item.id} />
                                }
                            </React.Fragment>
                        );
                    })
                        : (<div className="list-group-item"><h4 className="list-group-item-heading">{t('pos.productListPage.noProductFound')}</h4></div>)
                }
            </div>);
        
        const totalLength = sellableProductsAll ? sellableProductsAll.length : 0;
        const isMoreProduct = productsLength > posShowProductCount &&
                            totalLength !== productsLength &&
                            totalLength !== 0;

        return (
            <div className="payment-background-list">
                <DialogHeader text={t('pos.productListPage.products')} classicClass="posDialogClassic" classicClassFont="classicClassFont" />
                <div className="sales_product">
                    {productsItems}
                    {this.props.POSProductsScroll && isMoreProduct && <div className="row-flex justify-content-center">
                        <Button label="Load More" className="btn-loadMore" disabled={isLoading} onTouchTap={(e) => this.loadMore(e)}/>
                    </div>}
                </div>
                {!this.props.POSProductsScroll &&
                    <Pagination
                        length={productsLength}
                        itemsPerPage={posShowProductCount}
                        activePage={activePage}
                        onPageChange={this.props.updateActivePage}
                    />
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        productCategories: state.entity.productCategories,
        products: state.entity.sellableProducts,
        productsLength: state.entity.sellableProductsLength,
        searchText: state.form[`POSProductsProductSearch`],
        posOrder: state.entity.posOrder,
        POSCategory: state.form.POSCategory,
        posOrderSaveSuccess: state.form.posOrderSaveSuccess,
        branchId: state.common.branchId,
        productFilter: state.entity.productFilter,
        POSproductFiltered: state.entity.POSproductFiltered,
        POSBasicCategory: state.form[`POSTypeCheckbox`],
        POSSubCategory: state.form[`POSSpeciesCheckbox`],
        POSWeightsList: state.form[`POSWeightCheckbox`],
        POSBrandsList: state.form[`POSBrandCheckbox`],
        POSSortFilter: state.form[`SortFilter`],
        THC_MIN: state.form[`THCSliderMIN`],
        THC_MAX: state.form[`THCSliderMAX`],
        CBD_MIN: state.form[`CBDSliderMIN`],
        CBD_MAX: state.form[`CBDSliderMAX`],
        onSale: state.form[`POSOnSale`],
        onSaleMemberOnly: state.form[`POSOnSaleMemberOnly`],
        showImageInPOSPage: state.common.applicationSettings.showImageInPOSPage,
        posShowProductCount: state.common.applicationSettings.posShowProductCount,
        sellableProductsAll: state.entity.sellableProductsAll,
        loading: (state.common.ajaxCallsInProgress > 0) || state.common.loading,
        POSProductsScroll: state.common.applicationSettings.pOSProductsScroll !== false ? true : false
    };
}

function mapDispatchToProps(dispatch) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        getProducts: (filters) => dispatch(getSellableProducts(filters)),
        showError: (message) => dispatch(showError(message)),
        getProductbyId: (filter) => dispatch(getSellableProductById(filter)),
        setProductListEmpty: () => dispatch(setProductListEmpty()),
        clearPosFilter: () => dispatch(clearPosFilter())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductListPage))